import { Login } from 'pages/login';

export const LoginManagementRoute = () => {
  return <Login />;
};
